export default "__VITE_ASSET__DoXLqIZH__"